import { Spinner } from '@app/components/icons/spinner';
import { useFlag } from '@app/feature-flags/use-flag';
import { useAppDispatch } from '@app/store';
import { FLAG_POST_EVENT_ENABLE_CREATOR_LAB_CONSOLIDATION } from '@app/utilities/flags';
import React, { ReactNode, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, resolvePath } from 'react-router-dom';

import { Header } from './components/header';
import { selectRecordingFetchStatus } from './selector';

interface ContentPageProps {
  children: ReactNode;
  headerContextMenu?: ReactNode;
}

export const Layout = ({ children, headerContextMenu }: ContentPageProps) => {
  const isConsolidationEnabled = useFlag(
    FLAG_POST_EVENT_ENABLE_CREATOR_LAB_CONSOLIDATION,
  );

  // Hide lab tab when consolidation flag is enabled
  const tabs = useMemo(
    () => (isConsolidationEnabled ? ['editor'] : ['editor', 'lab']),
    [isConsolidationEnabled],
  );
  const dispatch = useAppDispatch();
  const fetchStatus = useSelector(selectRecordingFetchStatus);
  const isLoading = ['idle', 'processing'].includes(fetchStatus);
  const hasFailed = fetchStatus === 'failed';
  const libraryPath = resolvePath('../../../library', window.location.pathname);

  useEffect(() => {
    if (hasFailed) {
      dispatch({
        type: '[recording] fetch recording reset',
      });
    }
  }, [hasFailed, dispatch]);

  if (hasFailed) {
    return <Navigate to={libraryPath.pathname} replace />;
  }

  return (
    <div className="h-screen w-full bg-spring-neutral-base text-spring-neutral-b0 border-spring-neutral-b0/10">
      {isLoading ? (
        <Spinner size="large" className="mt-24" theme="dark" />
      ) : (
        <div className="flex flex-col h-full">
          <Header tabs={tabs} contextMenu={headerContextMenu} />
          <div className="flex-1 min-h-0">{children}</div>
        </div>
      )}
    </div>
  );
};
